import Datetime from 'react-datetime';
import Moment from 'moment';
import { makeStyles } from '@material-ui/styles';
import { grayColor } from 'assets/jss/material-dashboard-pro-react';
import DATA_RANGE_FORMAT from 'constants/dataRangeFormat';
import { isDatepickerValidDay } from 'helpers/dateHelpers';

const useStyles = makeStyles({
  label: {
    width: '100%',
    fontWeight: 'inherit',
    color: 'inherit',
  },
  text: {
    color: grayColor[2],
    fontWeight: '300',
  },
});

const DatePickerField = ({
  label,
  value,
  onChange,
  isValidDate = isDatepickerValidDay,
  timeFormat = false,
  dateFormat = Moment.localeData().longDateFormat('L'),
  closeOnSelect = true,
  inputProps = {},
  ...datetimeProps
}) => {
  const classes = useStyles();

  return (
    <label className={classes.label}>
      {label && <span className={classes.text}>{label}</span>}
      <Datetime
        isValidDate={isValidDate}
        timeFormat={timeFormat}
        dateFormat={dateFormat}
        closeOnSelect={closeOnSelect}
        value={value}
        onChange={MomentInstance => {
          onChange(
            MomentInstance?.format
              ? MomentInstance.format(DATA_RANGE_FORMAT)
              : MomentInstance,
            MomentInstance
          );
        }}
        inputProps={{
          readOnly: true,
          ...inputProps,
        }}
        {...datetimeProps}
      />
    </label>
  );
};

export default DatePickerField;
